export default "__VITE_ASSET__BmQBrMOH__"